import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import App from "./App";
import * as serviceWorker from './serviceWorker';
import historyHelper from './helpers/historyHelper'
import {Router} from "react-router-dom";

// Create browser history to use in the Redux store
//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');


// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore();
const rootElement = document.getElementById('root');

const render = Component => {
    return ReactDOM.render(
        <Provider store={store}>
            <Router history={historyHelper}>
                <Component />
            </Router>
        </Provider>,
        rootElement
    );
};

render(App);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();